import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {
    const roleMatched = useMemo(() => {
        // Check for empty authority first
        if (
            isEmpty(authority) ||
            isEmpty(userAuthority) ||
            typeof authority === 'undefined'
        ) {
            return !emptyCheck
        }

        // Check if user has required authority
        return authority.some((role) => userAuthority.includes(role))
    }, [authority, userAuthority, emptyCheck])

    return roleMatched
}

export default useAuthority
